import * as React from "react";
import { Row, Col } from "rsuite";
import { numberFormatter } from "../../utils";

export class CrossSellOpportunityL4 extends React.Component<any, any> {
    constructor(props: any) {
        super(props);
        this.state = {
        };
    }

    getStructuredData = (data: any) => {
        let obj: any = {};
        if (data) {
            data.list.forEach((d: any) => {
                if (!obj[d.l1]) {
                    obj[d.l1] = {
                        l1: d.l1,
                        list: [],
                    }
                }
                // if (d.marginOpportunity) {
                    obj[d.l1].list.push(d);
                // }
            });
            return Object.values(obj).filter((d: any) => d.list.length != 0);
        } return [];
    }

    handleSubCategoryClickLocal = (d1: any) => {
        this.props.handleSubCategoryClick(d1);
    }

    thousands = (value: any) => `${value}`.replace(/(?=(?!(\b))(\d{3})+$)/g, "$1,");

    render(): React.ReactNode {
        const { data, selectedSubCategory, clickedCustomerData, selectedL4Data } = this.props;
        let opportunityData = this.getStructuredData(data);
        let selectedL4 = selectedSubCategory ? selectedSubCategory.l4 : null;
        let netMargincross = selectedSubCategory ? selectedSubCategory.netMargin : null;
        let netQuantycross = selectedSubCategory ? selectedSubCategory.currentQty : null;
        let netSalescross = selectedSubCategory ? selectedSubCategory.netSales : null;
        return <Row className="show-grid">
            <Col style={{ marginBottom: "0.5%", paddingBottom: "0%", color: '#ffffff' }} className="subHeadCU subHeadCS" xs={24} sm={24} md={24}>
                {/* Customer Cross-Sell Opportunity */}
                {/* {clickedCustomerData && data && <><span style={{ fontSize: "0.8em", marginLeft: "1%", marginRight: "1%", color: "white" }}>
                    <span className="recommendLegend"></span>Current Portfolio</span>
                    <span style={{ fontSize: "0.8em", marginRight: "1%", color: "white" }}>
                        <span style={{ background: "#e6f5c6" }} className="recommendLegend"></span>Cross-Sell Opportunity</span>
                </>} */}
            </Col>
            {clickedCustomerData && data && selectedL4? <Col xs={24} sm={24} md={24}>
                <Row className="show-grid">
                    {/* <Col xs={24} sm={24} md={1} /> */}
                    <Col className="costOppTitle" style={{marginLeft : '2px' , marginRight : '5px'}}  xs={24} sm={24} md={5}>
                        <b> L3</b>
                    </Col>
                    <Col xs={24} sm={24} md={1} />
                    <Col className="costOppTitle" xs={24} sm={24} md={18}>
                        <b> L4</b>
                    </Col>
                </Row>
                {opportunityData.map((d: any) => <Row style={{ marginTop: "1%" , height : '155px'}} className="show-grid">
                    {/* <Col xs={24} sm={24} md={1} /> */}
                    <Col className="costOppSubTitle" style={{marginLeft : '2px' , marginRight : '5px'}} xs={24} sm={24} md={5}>
                        {selectedL4}
                    </Col>
                    <Col xs={24} sm={24} md={1} />
                    <Col xs={24} sm={24} md={18} className="clickedDataAlign">
                        {d.list.sort((a:any,b:any) => b.currentRevenue-a.currentRevenue).map((d1: any) => <span className="recommededL4" style={
                            selectedL4Data?.l4 == d1.l4 ? {
                                boxShadow: '0px 0px 6px 6px #c52015', background: `linear-gradient(
                                to right,
                                #93d502 0,
                                #93d502 ${(d1.currentRevenue / (d1.currentPortfolio + d1.currentRevenue)) * 100 + '%'},
                                #e6f5c6 ${(d1.currentRevenue / (d1.currentPortfolio + d1.currentRevenue)) * 100 + '%'},
                                #e6f5c6 100%
                            )` } : {
                                background: `linear-gradient(
                            to right,
                            #93d502 0,
                            #93d502 ${(d1.currentRevenue / (d1.currentPortfolio + d1.currentRevenue)) * 100 + '%'},
                            #e6f5c6 ${(d1.currentRevenue / (d1.currentPortfolio + d1.currentRevenue)) * 100 + '%'},
                            #e6f5c6 100%
                        )`}}
                            onClick={() => this.handleSubCategoryClickLocal(d1)}>
                            <label style={{ cursor: "pointer" }}><b className="recommendedL4Name">{d1.l4}</b></label>
                            <span style={{ position: 'absolute', left: 0, top: '100%', color: 'white' }}>${d1.currentRevenue > 1000 ? this.thousands(Math.round(d1.currentRevenue / 1000)) + 'K' : Math.round(d1.currentRevenue)}</span>
                            <span style={{ position: 'absolute', right: 0, top: '100%', color: 'white' }}>${d1.currentPortfolio < 0 ? 0 : d1.currentPortfolio > 1000 ? this.thousands(Math.round(d1.currentPortfolio / 1000)) + 'K' : Math.round(d1.currentPortfolio)}</span>
                        </span>)}
                    </Col>
                </Row>)}
                {/* <Row className="costOppSubTitleRow">
                    <Col xs={24} sm={24} md={8}><label style={{ color: "#A4F504", fontSize: "0.75vw" }}>Current Quantity (cs/year) : {numberFormatter(netQuantycross)}</label></Col>
                    <Col xs={24} sm={24} md={8}><label style={{ color: "#A4F504", fontSize: "0.75vw" }}>Current Sales($) : {numberFormatter(netSalescross)}</label></Col>
                    <Col xs={24} sm={24} md={8}><label style={{ color: "#A4F504", fontSize: "0.75vw" }}>Current Margin($) : {numberFormatter(netMargincross)}</label></Col>
                </Row> */}
            </Col> : <span className="divTextCenter">Click on above Product Class for detailed view</span>}
        </Row>
    }
}
// width: ((100 / d.list.length)- (d.list.length*3)) + '%'